import styled from 'styled-components';

const Root = styled.div `
  font-family: ${props => props.theme.fonts.museo};
  font-size: 14px;
  overflow: hidden;
  height: ${props => (props.$open ? 'auto' : '0px')};
`;

export { Root };
//# sourceMappingURL=styled.js.map
